<template>
    <transition name="fade">
        <div class="h-popup-box" v-if="visible">
            <div class="h-popup-inner">
                <h4><slot name="title"></slot></h4>
                <p><slot name="tip"></slot></p>
                <p>
                    <span class="cancel-btn" @click="closeDialog">{{ $t("common.cancelSpace") }}</span>
                    <span class="confirm-btn" @click="confirm">{{$t('common.trueText')}}</span>
                </p>
            </div>
        </div>
    </transition>
</template>
<script>
export default {
    name:'hPopup',
    data(){
        return{
            visible:false
        }
    },
    methods:{
        confirm(){
            this.$emit('confirm')
        },
        openDialog(){
            this.visible = true
        },
        closeDialog(){
            this.visible = false
        }
    }
}
</script>
<style lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: all 0.4s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(-10px);
}
.h-popup-box{
    width: 100%;
    height: 100%;
    background: rgba($color: #000000, $alpha: 0.5);
    position: fixed;
    left:0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 100;
    .h-popup-inner{
        width: 510px;
        height: 220px;
        position: absolute;
        left:0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        background: #fff;
        h4{
            height: 48px;
            line-height: 48px;
            background: #EFEFEF;
            padding-left: 30px;
            font-size: 20px;
            color: #000;
            text-align: left;
            font-weight: normal;
        }
        p{
            width: 450px;
            margin: 30px 30px 20px;
            line-height: 25px;
            font-size: 18px;
            text-align: left;
            span{
                float: left;
                width: 214px;
                height: 40px;
                line-height: 40px;
                border-radius:20px;
                font-size: 14px;
                text-align: center;
                cursor: pointer;
                &:first-of-type{
                    margin-right: 20px;
                    background: #EEF5FF;
                    color: $mainColor;
                }
                &:last-of-type{
                    background: $mainColor;
                    color: #fff;
                }
            }
        }
    }
}
</style>


